module.exports = __webpack_public_path__ + "img/1-2.705eeec9.svg";